import { LayoutAction, LayoutActionType, LayoutState } from './LayoutContext.interface';

/**
 * Manages layout state updates for page title and sidebar collapse state
 * @param state - Current layout state
 * @param action - Action to perform on the state
 * @returns Updated layout state
 * @throws {Error} In development if action type is not recognized
 */
export default function layoutReducer(state: LayoutState, action: LayoutAction): LayoutState {
    if (action === null || action === undefined) {
        return state;
    }

    switch (action.type) {
        case LayoutActionType.SET_PAGE_TITLE: {
            if (action.payload === state.pageTitle) {
                return state;
            }
            return { ...state, pageTitle: action.payload };
        }

        case LayoutActionType.SET_SIDEBAR_HIDDEN: {
            if (action.payload === state.isSidebarHidden) {
                return state;
            }
            return { ...state, isSidebarHidden: action.payload };
        }

        case LayoutActionType.TOGGLE_SIDEBAR: {
            return { ...state, isSidebarHidden: !state.isSidebarHidden };
        }

        case LayoutActionType.SET_LAUNCHPAD_VISIBLE: {
            return { ...state, isLaunchpadVisible: action.payload };
        }

        case LayoutActionType.SET_HEADER_IN_BLEND_MODE: {
            return { ...state, isHeaderInBlendMode: action.payload };
        }

        case LayoutActionType.SET_NAVIGATION_INTERCEPTOR: {
            return { ...state, navigationInterceptor: action.payload };
        }

        case LayoutActionType.REGISTER_BOTTOM_RIGHT_POPUP: {
            if (state.activeBottomRightPopup === action.payload) {
                return state;
            }
            return { ...state, activeBottomRightPopup: action.payload };
        }

        case LayoutActionType.UNREGISTER_BOTTOM_RIGHT_POPUP: {
            if (state.activeBottomRightPopup !== action.payload) {
                return state;
            }
            return { ...state, activeBottomRightPopup: null };
        }

        default: {
            if (process.env.NODE_ENV !== 'production') {
                throw new Error(`Unhandled action type: ${(action as LayoutAction).type}`);
            }
            return state;
        }
    }
}
